import { useState, useEffect } from 'react';
import { DateInput } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

const formatDate = (date) => date.split('T')[0];

const ReschedulingForm = ({ dates, setFieldValue, errors }) => {
  const [maxResponseDate, setMaxResponseDate] = useState(null);
  const actualDate = formatDate(new Date().toISOString());
  const { realizationDate, responseDate } = dates;

  useEffect(() => {
    setMaxResponseDate(formatDate(realizationDate));
  }, [realizationDate]);

  return (
    <div>
      <DateInput
        errors={errors?.dates?.realizationDate}
        isInvalid={errors?.dates?.realizationDate}
        label="Fecha probable de realización"
        min={actualDate}
        name="realizationDate"
        onChange={(e) => {
          setFieldValue('dates', {
            responseDate: '',
            realizationDate: e.target.value
          });
        }}
        onClear={() => {
          setFieldValue('dates', {
            responseDate: '',
            realizationDate: ''
          });
        }}
        value={formatDate(realizationDate)}
      />
      <DateInput
        errors={errors?.dates?.responseDate}
        isInvalid={errors?.dates?.responseDate}
        label="Fecha de necesidad de respuesta"
        max={maxResponseDate}
        min={actualDate}
        name="responseDate"
        onChange={(e) => {
          setFieldValue('dates', {
            ...dates,
            responseDate: e.target.value
          });
        }}
        onClear={() => {
          setFieldValue('dates', {
            responseDate: '',
            realizationDate
          });
        }}
        value={formatDate(responseDate)}
      />
    </div>
  );
};

ReschedulingForm.propTypes = {
  dates: PropTypes.shape({
    realizationDate: PropTypes.string,
    responseDate: PropTypes.string
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    dates: PropTypes.shape({
      realizationDate: PropTypes.string,
      responseDate: PropTypes.string
    })
  }).isRequired
};

export default ReschedulingForm;
